// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/section-image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0C4n.ttf) format('truetype');
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4n.ttf) format('truetype');
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4n.ttf) format('truetype');
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4n.ttf) format('truetype');
}
.Section {
  display: flex;
  width: 100vw;
  height: 120px;
  flex-shrink: 0;
  background: #323640;
  overflow: hidden;
  position: relative;
  overflow-x: hidden;
}
.section-image {
  width: 800px;
  flex-shrink: 0;
  opacity: 0.4;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), lightgray 50% / cover no-repeat;
  overflow: hidden;
  object-fit: cover;
}
@media screen and (max-width: 1200px) {
  .section-image {
    display: none;
  }
}
.overlay {
  flex: 1 1;
  padding: 50px;
  position: relative;
}
.frame {
  border-radius: 20px;
  background: #373c47;
  padding-left: 40px;
  padding-top: 20px;
  padding-bottom: 20px;
  position: absolute;
  left: -300px;
  right: 60px;
}
@media screen and (max-width: 1200px) {
  .frame {
    left: 100px;
  }
}
.rectangle {
  width: 5px;
  height: 15px;
  transform: rotate(90deg);
  margin-left: 10px;
  margin-bottom: 10px;
  border-radius: 1px;
  border: 6px solid;
  border-image: linear-gradient(90deg, #6cffc8, #66d1ff);
  border-image-slice: 1;
}
.section-p {
  color: #ccc;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5;
  margin: 0 0 0 0;
}
.section-scientia {
  background: linear-gradient(90deg, #6cffc8 4.08%, #66d1ff 95.54%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["https:/fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap","webpack://./src/components/Section.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;ADCA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;ADCA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;ADCA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;AA5BA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA8BF;AA5BA;EACE,YAAA;EAEA,cAAA;EACA,YAAA;EAEA,oFAAA;EACA,gBAAA;EACA,iBAAA;AA4BF;AA3BE;EAAA;IACE,aAAA;EA8BF;AACF;AA3BA;EACE,SAAA;EACA,aAAA;EACA,kBAAA;AA6BF;AA1BA;EACE,mBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,YAAA;EACA,WAAA;AA0BF;AAxBE;EAAA;IACE,WAAA;EA2BF;AACF;AAzBA;EACE,UAAA;EACA,YAAA;EACA,wBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sDAAA;EACA,qBAAA;AA2BF;AAzBA;EACE,WAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA2BF;AAxBA;EACE,iEAAA;EAKA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAsBF","sourcesContent":["@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 300;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0C4n.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4n.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4n.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4n.ttf) format('truetype');\n}\n","@import \"../styles/scientia-colors.less\";\n@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap');\n\n.Section {\n  display: flex;\n  width: 100vw;\n  height: 120px;\n  flex-shrink: 0;\n  background: @background-grey;\n  overflow: hidden;\n  position: relative;\n  overflow-x: hidden;\n}\n.section-image {\n  width: 800px;\n  // height: 133px;\n  flex-shrink: 0;\n  opacity: 0.4;\n\n  background: url(../images/section-image.png), lightgray 50% / cover no-repeat;\n  overflow: hidden;\n  object-fit: cover;\n  @media screen and (max-width: 1200px) {\n    display: none;\n }\n}\n\n.overlay {\n  flex: 1;\n  padding: 50px;\n  position: relative;\n\n}\n.frame {\n  border-radius: 20px;\n  background: @section-grey;\n\n  padding-left: 40px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  position: absolute;\n\n  left: -300px;\n  right: 60px;\n\n  @media screen and (max-width: 1200px) {\n    left: 100px;\n }\n}\n.rectangle {\n  width: 5px;\n  height: 15px;\n  transform: rotate(90deg);\n  margin-left: 10px;\n  margin-bottom: 10px;\n  border-radius: 1px;\n  border: 6px solid;\n  border-image: linear-gradient(90deg, @scientia-green, @scientia-blue);\n  border-image-slice: 1;\n}\n.section-p {\n  color: @grey;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 1.5;\n  margin: 0 0 0 0;\n}\n\n.section-scientia {\n  background: linear-gradient(\n    90deg,\n    @scientia-green 4.08%,\n    @scientia-blue 95.54%\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
